const { STUDENT_BULK_TEMPLATE } = process.env

const studentBulkTemplate = STUDENT_BULK_TEMPLATE

export default studentBulkTemplate
